var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" }, attrs: { grow: "" } },
    [
      _c("w-card-title", [_vm._v(" " + _vm._s(_vm.$ct("pdf-preview")) + " ")]),
      _c("w-card-content", { style: { padding: "0 0 0 0" } }, [
        _c("iframe", { attrs: { id: "pdf-frame", src: _vm.url } }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }